/**
 * Upload multiple images to the server
 * @param files - Array of File objects to upload
 * @param relatedRecordType - The model class name (e.g., 'App\\Models\\ScaffoldingHandover')
 * @param relatedRecordId - The ID of the related record
 * @param csrfToken - CSRF token for authentication
 * @returns Promise that resolves to an array of uploaded image objects
 */
export async function uploadImages(files: File[], relatedRecordType: string, relatedRecordId: string, csrfToken: string): Promise<any[]> {
    if (files.length === 0) return [];
    const uploadPromises = files.map(async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('related_record_type', relatedRecordType);
        formData.append('related_record_id', relatedRecordId);

        const response = await fetch('/images/upload', {
            method: 'POST',
            body: formData,
            headers: {
                'X-CSRF-TOKEN': csrfToken,
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to upload ${file.name}`);
        }

        const data = await response.json();
        return data.image;
    });

    return await Promise.all(uploadPromises);
}
